module.exports = __webpack_public_path__ + "static/media/banner_SabaSport.065e0201.png";